<tt-page *ngIf="page">
    <tt-divider>
        <tt-divider-rows (ttResizeEnd)="onGridResized()">
            <tt-divider-pane ttSize="33">
                <tt-divider-columns (ttResizeEnd)="onGridResized()">
                    <tt-divider-pane *ngIf="showFilters" ttSize="25">
                        <tt-card class="col-xs-12 sp-0">
                            <form (ngSubmit)="searchItems()">
                                <tt-input ttLabel="ordersearch" ttRememberId="ediorderheads.ordersearch" ttOnlyRemember
                                    [ttModel]="page.ordersearch" (ttModelChange)="onSearchChanged($event)" (ttOnBlur)="onSearchBlur()" ttShowClearButton>
                                    <ng-container buttons>
                                        <tt-form-field-button ttIcon="fas fa-search" (ttClick)="searchItems()" [ttDisabled]="searching"></tt-form-field-button>
                                    </ng-container>
                                </tt-input>
                            </form>
                            <tt-select ttLabel="status" ttRememberId="ediorderheads.status_id" ttOnlyRemember
                                [ttModel]="page.status_id" (ttModelChange)="onStatusChanged($event)"
                                [ttData]="statuses" ttDataId="orderstatus_id" ttDataName="orderstatus_name"></tt-select>
                            <tt-date-range ttLabel="orderdate_fom_tom" ttRememberId="ediorderheads" ttOnlyRemember
                                [ttModel]="page" (ttModelChange)="onDateRangeChanged($event)"></tt-date-range>
                        </tt-card>
                    </tt-divider-pane>
                    <tt-divider-pane [ttSize]="showFilters ? 75 : 100">
                        <div class="edi-grid hidden-xs hidden-sm">
                            <tt-grid *ngIf="gridHead" [ttOptions]="gridHead" (ttReady)="onHeadReady($event)"></tt-grid>
                        </div>
                    </tt-divider-pane>
                </tt-divider-columns>
            </tt-divider-pane>
            <tt-divider-pane ttSize="33">
                <div *ngIf="+page.selected_edi_orderhead_keyno > 0" class="edi-grid hidden-xs hidden-sm">
                    <tt-grid *ngIf="gridLine" [ttOptions]="gridLine" (ttReady)="onLineReady($event)"></tt-grid>
                </div>
            </tt-divider-pane>
            <tt-divider-pane ttSize="33">
                <div *ngIf="+page.selected_edi_orderhead_keyno > 0" class="edi-grid hidden-xs hidden-sm">
                    <tt-grid *ngIf="gridProperty" [ttOptions]="gridProperty" (ttReady)="$event && onGridResized()"></tt-grid>
                </div>
            </tt-divider-pane>
        </tt-divider-rows>
    </tt-divider>
</tt-page>
